import { type FC } from 'react';

import { useCardOfferDataContext } from '@/microfrontends/listing/shared/context/selectors/cardData';
import { useCAForCard } from '@/microfrontends/listing/shared/hooks/useCAForCard';

import { stopPropagation } from '@/packages/utils/event/stopPropagation';

import { SpecialGeoList } from './internal/components/SpecialGeoList/SpecialGeoList';

export const SpecialGeoListContainer: FC = () => {
  const {
    geo: { transports },
  } = useCardOfferDataContext();

  const caForCard = useCAForCard();

  return (
    <SpecialGeoList
      trackClick={(): void => caForCard({ action: 'click_sopr', category: 'Listing', label: 'to_listing_waypoint' })}
      transports={transports}
      onClick={stopPropagation}
    />
  );
};
